import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Slider from '../Elements/Slider3';
import About from '../Elements/About';
import Specialization from '../Elements/Specialization';
import Callus from '../Elements/Callus';
import OurServices from '../Elements/OurServices';
// import OurProject3 from '../Elements/OurProject3';

class Home3 extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Slider />
          <About />
          <Specialization />
          <Callus />
          <OurServices />
          {/* {false && <OurProject3 />} */}
        </div>
        <Footer blocked />
      </>
    );
  };
};

export default Home3;
